import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const VanuatuFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16278'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16278)'>
				<g filter='url(#filter0_d_2332_16278)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14H20V8.40002H0V14Z'
						fill='#009543'
					/>
				</g>
				<g filter='url(#filter1_d_2332_16278)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 5.6H20V0H0V5.6Z'
						fill='#D21034'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 8.39998H20V5.59998H0V8.39998Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L9.52381 7L0 14V0Z'
					fill='#262626'
				/>
				<path
					d='M-0.286458 11.7781V2.22196L6.46433 7.00002L-0.286458 11.7781Z'
					stroke='#FDCE12'
					strokeWidth='1.33333'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 7.46666H19.9993V6.53333H6.66602V7.46666Z'
					fill='#FDCE12'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_16278'
					x='0'
					y='8.40002'
					width='20'
					height='5.59998'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_16278'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_16278'
						result='shape'
					/>
				</filter>
				<filter
					id='filter1_d_2332_16278'
					x='0'
					y='0'
					width='20'
					height='5.59998'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_16278'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_16278'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default VanuatuFlagIcon;
